import React, { useEffect, useState } from 'react';

export default function TextViewer({ file }) {
  const [text, setText]   = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!file) return;
    let active = true;
    const token = localStorage.getItem('kspro_token');
    const base = file._isPersonal ? '/api/personal-files' : '/api/project-files';
    fetch(`${base}/${file._id}/download`, { headers: { 'x-auth-token': token } })
      .then(res => { if (!res.ok) throw new Error(); return res.text(); })
      .then(t => { if (active) setText(t); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [file?._id]);

  if (error)      return <div className="fm-loading">Failed to load file.</div>;
  if (text === null) return <div className="fm-loading">Loading…</div>;

  return (
    <div className="txt-viewer">
      <div className="txt-viewer-header">{file.filename}</div>
      <pre className="txt-viewer-body">{text}</pre>
    </div>
  );
}
